export const VALIDATOR_ERROR_MESSAGES = {
  MIN_LENGHT_ERROR: 'MIN_LENGHT_ERROR',
  MAX_LENGTH_ERROR: 'MAX_LENGTH_ERROR',
  REQUIRED_ERROR: 'REQUIRED_ERROR',
};
